module.exports = __webpack_public_path__ + "static/media/file_drawer.38f9461d.svg";